import Cropper from 'cropperjs';

const OFFSET = 32;

const getCanvasData = (width: number, height: number) => ({
    left: OFFSET,
    top: OFFSET,
    width: width - 2 * OFFSET,
    height: height - 2 * OFFSET,
});

export const initCropper = (cropper: Cropper) => {
    cropper.setDragMode('move');
    const { width, height } = cropper.getContainerData();
    const initialDimensions = getCanvasData(width, height);

    cropper.setCanvasData(initialDimensions);
    cropper.setCropBoxData(initialDimensions);

    const canvasData = cropper.getCanvasData();
    return Math.min(canvasData.width / canvasData.naturalWidth, canvasData.height / canvasData.naturalHeight);
};

export const initProductImageCropper = (cropper: Cropper) => {
    cropper.setDragMode('move');
    const { width, height } = cropper.getContainerData();
    const canvasData = cropper.getCanvasData();

    const initialDimensions = getCanvasData(width, height);

    const initialZoom = Math.min(
        (initialDimensions.width - OFFSET) / canvasData.naturalWidth,
        (initialDimensions.height - OFFSET) / canvasData.naturalHeight,
    );

    const canvasWidth = initialZoom * canvasData.naturalWidth;
    const canvasHeight = initialZoom * canvasData.naturalHeight;

    cropper.setCropBoxData(initialDimensions);
    cropper.setCanvasData({
        left: (width - canvasWidth) / 2,
        top: (height - canvasHeight - OFFSET) / 2,
        width: canvasWidth,
        height: canvasHeight,
    });

    return initialZoom;
};
